import { createListenerMiddleware } from "@reduxjs/toolkit";
import ApiService from "../../shared/services/ApiService.js";
import { configActions } from "./reducer.js";
const listenerMiddleware = createListenerMiddleware();
listenerMiddleware.startListening({
  actionCreator: configActions.setApiRoot,
  effect: (action) => {
    ApiService.getInstance().updateConfig({
      baseUrl: action.payload
    });
  }
});
const { middleware: configMiddleware } = listenerMiddleware;
export {
  configMiddleware
};
